"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promoVideoComponent = exports.SpotGroupRenderPreview = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var webexUI_1 = require("webexUI");
var PreviewImage_1 = require("./PreviewImage");
var SpotGroupRenderPreview = /** @class */ (function (_super) {
    tslib_1.__extends(SpotGroupRenderPreview, _super);
    function SpotGroupRenderPreview() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selector = '.spot-cascade .img-empty-wrapper';
        return _this;
    }
    SpotGroupRenderPreview.prototype.OnInit = function () {
        var _this = this;
        var emptyImgCTAs = [];
        this.el.forEach(function (el) {
            return el.querySelectorAll('.cta--play-video').forEach(function (item) { return emptyImgCTAs.push(item); });
        });
        var emptyImgCTA = emptyImgCTAs[0];
        var playButtonAriaLabel = emptyImgCTA.getAttribute('aria-label');
        var popupAriaLabel = emptyImgCTA.getAttribute('data-popup-aria-label');
        var closeButtonAriaLabel = emptyImgCTA.getAttribute('data-close-button-aria-label');
        var videoUrls = $.makeArray(emptyImgCTAs.map(function (el) {
            return el.getAttribute('data-url');
        }));
        videoUrls.forEach(function (videoUrl, index) {
            if (webexUI_1.VideoService.checkIfYoutube(videoUrl)) {
                (0, PreviewImage_1.RenderPreviewImage)(videoUrl, _this.el[index], playButtonAriaLabel, popupAriaLabel, closeButtonAriaLabel);
            }
            else {
                _this.el.forEach(function (el) {
                    return el
                        .querySelectorAll('.img-empty')
                        .forEach(function (item) { return item.classList.toggle('img-empty img-video-empty'); });
                });
            }
        });
    };
    return SpotGroupRenderPreview;
}(app_1.Component));
exports.SpotGroupRenderPreview = SpotGroupRenderPreview;
exports.promoVideoComponent = new SpotGroupRenderPreview();
